import * as React  from 'react'
import { connect } from 'react-redux'

import InputAdornment     from '@material-ui/core/InputAdornment'
import { TextFieldProps } from '@material-ui/core/TextField'

import { selectCurrency } from '../../redux/ducks'
import EnhancedTextField  from './EnhancedTextField'

const mstp = state => ({ currency: selectCurrency(state) })

type Props =
  TextFieldProps
  & ReturnType<typeof mstp>

const CurrencyTextField = (props: Props) => {
  const currencyStartAdornment = (
    <InputAdornment position="start">
      {props.currency}
    </InputAdornment>
  )

  return (
    <EnhancedTextField
      type={'number'}
      InputProps={{ startAdornment: currencyStartAdornment }}
      {...props}
    />
  )
}

export default connect(mstp)<TextFieldProps>(CurrencyTextField)



// WEBPACK FOOTER //
// ./src/components/atoms/CurrencyTextField.tsx